import styles from './StaffList.css'
import OutletCell from './OutletCell'
import EmailStatus from './EmailStatus'

class StaffList extends React.Component {
  render () {
    const {employees, employeeDetail} = this.props
    return <div className={styles['wrapper']}>
      <table className={styles['table-header']}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Role</th>
            <th>Email</th>
            <th className={styles['email-status']}>Email Status</th>
            <th className={styles['outlet']}>Outlet</th>
          </tr>
        </thead>
      </table>
      <div className={`${styles['table-content-wrapper']} staff-table-content-wrapper`}>
        <table className={`${styles['table-content']}`}>
          <tbody>
            {employees.map((employee) => this._row({employee, employeeDetail}))}
          </tbody>
        </table>
      </div>
    </div>
  }

  _row = ({employee, employeeDetail}) => {
    const {outlets} = this.props
    let className = ''
    if (employeeDetail && employeeDetail.id === employee.id) {
      className = styles.selected
    }

    return <tr className={`${className}`} onClick={() => { this.props.onClickRow({employee}) }}>
      <td>{employee.first_name} {employee.last_name}</td>
      <td className={styles['role']}>{employee.role && employee.role.name}</td>
      <td>{employee.email}</td>
      <td className={styles['email-status']}>
        <EmailStatus
          confirmed={employee.is_email_confirmed}
          email={employee.email}
          onClickResendInvitation={({email}) => { this.props.onClickResendInvitation({email}) }}
        />
      </td>
      <td className={styles['outlet']}>
        <OutletCell outlets={employee.outlets} allOutlet={employee.outlets.length === outlets.length} />
      </td>
    </tr>
  }
}

StaffList.propTypes = {
  employees: React.PropTypes.array,
  employeeDetail: React.PropTypes.object,
  onClickRow: React.PropTypes.func,
  outlets: React.PropTypes.array,
  onClickResendInvitation: React.PropTypes.func
}
export default StaffList



// WEBPACK FOOTER //
// ./app/pages/Employees/Staff/StaffList/StaffList.js